import React, { useEffect, useRef, useState } from 'react'
import moment from 'moment/moment'
import { CountdownTimeRemaining, CountdownTimerProps } from './CountdownTimer.types'

export const CountdownTimer = ({ time, onCountdownEnd }: CountdownTimerProps) => {
    const intervalRef = useRef<ReturnType<typeof setInterval> | null>(null)
    const [timer, setTimer] = useState('00:00')

    const getTimeRemaining = (deadline: Date): CountdownTimeRemaining => {
        const total = deadline.getTime() - Date.now()
        const seconds = Math.floor((total / 1000) % 60)
        const minutes = Math.floor((total / 1000 / 60) % 60)
        const hours = Math.floor((total / 1000 / 60 / 60) % 24)
        return {
            total,
            hours,
            minutes,
            seconds,
        }
    }

    const startTimer = (deadline: Date) => {
        const { total, minutes, seconds } = getTimeRemaining(deadline)
        if (total >= 0) {
            setTimer((minutes > 9 ? minutes : '0' + minutes) + ':' + (seconds > 9 ? seconds : '0' + seconds))
        } else {
            if (intervalRef.current) {
                clearInterval(intervalRef.current)
                intervalRef.current = null
            }

            if (onCountdownEnd) {
                onCountdownEnd()
            }
        }
    }

    const clearTimer = (deadline: Date) => {
        setTimer(moment(+time * 1000).format('mm:ss'))

        if (intervalRef.current) {
            clearInterval(intervalRef.current)
        }
        const id = setInterval(() => {
            startTimer(deadline)
        }, 1000)
        intervalRef.current = id
    }

    const getDeadTime = (): Date => {
        const deadline = new Date()

        deadline.setSeconds(deadline.getSeconds() + +time)
        return deadline
    }

    useEffect(() => {
        clearTimer(getDeadTime())

        return () => {
            if (intervalRef.current) {
                clearInterval(intervalRef.current)
            }
        }
    }, [])

    return <>{timer}</>
}
